import React from 'react';
import { motion } from 'framer-motion';

const Contactusmap = () => {
    return (
             <motion.div
              initial={{y:100, opacity:0}}
              whileInView={{y:0, opacity:1}}
              transition={{delay:0.2, 
               y:{type:"spring", 
              stiffness:60}, 
              opacity:{duration:1},
              ease:"easeIn", duration:1}}
             className='relative'>
              {/* <div className='bg-[#1e336a] h-[80vh] w-full rounded-[25px] absolute -z-0'></div> */}
                 {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.92880460662!2d77.06876027408613!3d28.451562492278253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1904846182c9%3A0x339d6935dcb76db3!2sOahfeo%20Workspaces%20%3A%20The%20Underground%20Oasis%20%7C%20Best%20Coworking%20Space%20in%20Gurugram%20%7C%20Private%20Office%20on%20Rent%20%7C%20Virtual%20Office!5e0!3m2!1sen!2sin!4v1714293410083!5m2!1sen!2sin" width="600" height="450"  allowFullScreen referrerPolicy="no-referrer-when-downgrade"   className="relative z-[5px]  w-full h-[80vh] border-2 border-[#51a9ff]"></iframe> */}
                 <iframe frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?hl=en&amp;q=Easy-Campus, An End-To-End Campus Placement Solution&amp;t=&amp;z=11&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" width="600" height="450"  allowFullScreen referrerPolicy="no-referrer-when-downgrade"   className="relative z-[5px]  w-full h-[90vh] border-2 border-[#51a9ff]"></iframe>
              </motion.div>
    )
  }
  
  export default Contactusmap